import { render, staticRenderFns } from "./SenderSettings.vue?vue&type=template&id=7ba2fb78&"
import script from "./SenderSettings.vue?vue&type=script&lang=js&"
export * from "./SenderSettings.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports